import { create } from 'zustand';
import type { Task } from '@underline/shared';
import type { EventWithTasks } from '@/hooks/use-events';

export type DashLayout = 'cards' | 'lista';
const DASH_LAYOUT_KEY = 'u-dash-layout';
function readDashLayout(): DashLayout {
  try {
    return localStorage.getItem(DASH_LAYOUT_KEY) === 'lista' ? 'lista' : 'cards';
  } catch {
    return 'cards';
  }
}

interface UiState {
  /* Layout do Painel (persistido) */
  dashLayout: DashLayout;
  setDashLayout: (layout: DashLayout) => void;

  /* Create sheet (FAB +) */
  createOpen: boolean;
  openCreate: () => void;
  closeCreate: () => void;
  toggleCreate: () => void;

  /* Event form (criar OU editar) */
  eventFormOpen: boolean;
  editingEvent: EventWithTasks | null;
  eventFormInstance: number;
  openNewEvent: () => void;
  openEditEvent: (event: EventWithTasks) => void;
  setEditingEvent: (event: EventWithTasks | null) => void;
  closeEventForm: () => void;

  /* Task form (criar OU editar) */
  taskFormOpen: boolean;
  editingTask: Task | null;
  taskFormInstance: number;
  openNewTask: () => void;
  openEditTask: (task: Task) => void;
  setEditingTask: (task: Task | null) => void;
  closeTaskForm: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  dashLayout: readDashLayout(),
  setDashLayout: (layout) => {
    try {
      localStorage.setItem(DASH_LAYOUT_KEY, layout);
    } catch {
      // ignore — sessão sem storage
    }
    set({ dashLayout: layout });
  },

  createOpen: false,
  openCreate: () => set({ createOpen: true }),
  closeCreate: () => set({ createOpen: false }),
  toggleCreate: () => set((s) => ({ createOpen: !s.createOpen })),

  eventFormOpen: false,
  editingEvent: null,
  eventFormInstance: 0,
  openNewEvent: () =>
    set((s) => ({
      eventFormOpen: true,
      editingEvent: null,
      createOpen: false,
      eventFormInstance: s.eventFormInstance + 1,
    })),
  openEditEvent: (event) =>
    set((s) => ({
      eventFormOpen: true,
      editingEvent: event,
      eventFormInstance: s.eventFormInstance + 1,
    })),
  setEditingEvent: (event) => set({ editingEvent: event }),
  closeEventForm: () => set({ eventFormOpen: false, editingEvent: null }),

  taskFormOpen: false,
  editingTask: null,
  taskFormInstance: 0,
  openNewTask: () =>
    set((s) => ({
      taskFormOpen: true,
      editingTask: null,
      createOpen: false,
      taskFormInstance: s.taskFormInstance + 1,
    })),
  openEditTask: (task) =>
    set((s) => ({
      taskFormOpen: true,
      editingTask: task,
      taskFormInstance: s.taskFormInstance + 1,
    })),
  setEditingTask: (task) => set({ editingTask: task }),
  closeTaskForm: () => set({ taskFormOpen: false, editingTask: null }),
}));
